import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';

@NgModule({
    declarations: [],
    imports: [IonicModule, CommonModule, RouterModule,
PageNotFoundComponent],
    exports: [PageNotFoundComponent],
})
export class AuthComponentsModule {}
